export default "__VITE_ASSET__Bs5J4Gx3__"